import { createApiEffect } from '@/features/api/common/create-api-effect'
import { RelationsType } from '@/features/api/subject/types'

export const checkThemeRelationsFx = createApiEffect<number, RelationsType>({
  requestMapper: (id) => ({
    method: 'GET',
    url: `/api/subject-app/themes/${id}/relations/`,
  }),
})
